import React from 'react';

const HighlightedCell = ({ children, searchTerm, searchIndex }) => {
  const highlightedText = () => {
    const parts = String(children).split(
      new RegExp(`(${searchTerm})`, 'gi')
    );

    return parts.map((part, i) =>
      part.toLowerCase() === searchTerm.toLowerCase() ? (
        <span key={i} style={{ backgroundColor: 'blue', color: 'white' }}>
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  return <>{highlightedText()}</>;
};

export default HighlightedCell;